<script setup>

import { getUser } from '@/services/api/auth.js'
import { getCurrentInstance } from 'vue'
import { useI18n } from 'vue-i18n'
import { atorAtual } from '@/services/personificacao.js'
const { appContext } = getCurrentInstance();
const APP_NAME = appContext.config.globalProperties.APP_NAME;
const APP_VERSION = appContext.config.globalProperties.version;
const LIBERTY_MOCK = appContext.config.globalProperties.LIBERTY_MOCK;
const user = getUser()
const version =  APP_NAME + " " + APP_VERSION
const { t } = useI18n()

// A faixa no topo já avisa; isto aqui é o segundo lugar que precisa dizer a
// mesma coisa, porque é o nome que fica visível o tempo todo -- quando ela
// não aparece (por exemplo, se a faixa sumir de uma tela) o nome sozinho
// ainda denuncia que não é a própria conta.
const ator = atorAtual()

defineOptions({
    name: 'AdminProfile'
})
</script>

<template>
    <v-menu>
        <template v-slot:activator="{ props }">
            <button class="profile-btn align-items-center" v-bind="props">
                <v-img src="/images/admin.png" alt="admin" />
                <span class="fw-semibold text-black">{{ user.name}}</span>
                <span v-if="ator" class="badge-personificado" :title="t('common.personificacao.marcador', { ator })">
                    <i class="material-symbols-outlined">swap_horiz</i>
                </span>

            </button>
        </template>
        <v-list class="profile-menu-dropdown">
            <div class="admin d-flex align-items-center">
                <div>
                    <span v-if="getUser" class="d-block text-black fw-medium text-capitalize">
                        {{ user.fullname }}
                    </span>
                </div>
            </div>
            <ul class="list pl-0 mt-0 mb-0 list-unstyled">
                <li>
                    <router-link
                        to="/my-profile"
                        class="d-block position-relative"
                    >
                        <i class="material-symbols-outlined">account_circle</i>
                        {{ $t('common.topHeader.myProfile') }}
                    </router-link>
                </li>
            </ul>
            <div class="border-top"></div>
            <ul class="list pl-0 mt-0 mb-0 list-unstyled">
                <li>
                    <router-link to="/settings" class="d-block position-relative">
                        <i class="material-symbols-outlined">settings </i>
                        {{$t("common.sidebar.settings")}}
                    </router-link>
                </li>
                <li>
                    <router-link
                        to="/logout"
                        class="d-block position-relative"
                    >
                        <i class="material-symbols-outlined">logout </i>
                        {{ $t('common.topHeader.logout') }}
                    </router-link>
                </li>
                <div class="border-top"></div>
                <span class="text-light ml-5 font-size-12">{{ version }}</span>
            </ul>
        </v-list>
    </v-menu>
</template>

<style scoped>
.badge-personificado {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin-left: 6px;
    border-radius: 50%;
    background: #ffcb05;
    color: #1f2937;
}

.badge-personificado .material-symbols-outlined {
    font-size: 14px;
}
</style>
